import PurchaseButton from './purchaseButton'

export default PurchaseButton
